import { normalizePath } from './normalizePath'

const unauthenticatedPaths = [
  '/authenticate/login',
  '/authenticate/masquerade-login',
  '/authenticate/signup',
  '/authenticate/forgot-password',
  '/authenticate/reset-password',
  '/authenticate/email-verify',
  '/authenticate/invite',
  '/authenticate/invite-expired',
  '/authenticate/invite-sent',
  '/maintenance',
]

export function isUnauthenticatedPath(path) {
  return unauthenticatedPaths.includes(normalizePath(path))
}
